import { render, staticRenderFns } from "./CurrentTimeParts.vue?vue&type=template&id=228b5241&scoped=true"
import script from "./CurrentTimeParts.vue?vue&type=script&lang=ts"
export * from "./CurrentTimeParts.vue?vue&type=script&lang=ts"
import style0 from "./CurrentTimeParts.vue?vue&type=style&index=0&id=228b5241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b5241",
  null
  
)

export default component.exports